import {
  ContentBreadcrumbFragment_context,
  GetMyExams_examSyllabusList,
} from "__generated__/types";
import { BreadcrumbItem } from "common/components/breadcrumb/Breadcrumb";
import { urlByType } from "domain/common/url-utils";
import {
  administrationBreadcrumb,
  homeBreadcrumb,
} from "domain/pages/breadcrumbs";
import { urls } from "common/urls";
import { ContentInList } from "common/hooks/useBreadcrumbs";

export function buildBreadcrumbs(
  context: ContentBreadcrumbFragment_context[],
  isAdminPage: boolean,
  isSyllabusInContext: boolean,
): BreadcrumbItem[] {
  return context.map((p) => {
    const item: BreadcrumbItem = {
      name: p.title,
      path: urlByType(p.__typename, p.id, isAdminPage, isSyllabusInContext),
    };

    return item;
  });
}

export function decorateBreadcrumbs(
  breadcrumbs: BreadcrumbItem[],
  isAdminPage: boolean,
  syllabusInContext: ContentInList,
  myExamSyllabi: GetMyExams_examSyllabusList[] | undefined,
): BreadcrumbItem[] {
  const isSyllabusForStudent = !!myExamSyllabi?.some(
    (e) => e.id === syllabusInContext.value?.id,
  );
  const isLibraryContent = syllabusInContext.value && !isSyllabusForStudent;

  if (isAdminPage) {
    return [...administrationBreadcrumb, ...breadcrumbs];
  } else if (isSyllabusForStudent) {
    return [
      ...homeBreadcrumb,
      ...breadcrumbs.slice(0, syllabusInContext.index),
      { path: urls.myStudies, name: "Pensumet mitt" },
      ...breadcrumbs.slice(syllabusInContext.index),
    ];
  } else if (isLibraryContent) {
    return [
      ...homeBreadcrumb,
      ...breadcrumbs.slice(0, syllabusInContext.index),
      { path: urls.library, name: "Biblioteket" },
      ...breadcrumbs.slice(syllabusInContext.index),
    ];
  } else {
    return [...homeBreadcrumb, ...breadcrumbs];
  }
}
